import {
    pending,
    processing,
    offTrack,
    onTrack,
    goalReached,
    completed,
    expired,
} from '../constants/pacingStatus';

export const getStatusLabel = status => {
    switch (status) {
        case pending:
            return 'PENDING';

        case processing:
            return 'PROCESSING';

        case offTrack:
            return 'OFF TRACK';

        case onTrack:
            return 'ON TRACK';

        case goalReached:
            return 'GOAL REACHED';

        case completed:
            return 'COMPLETED';

        case expired:
            return 'EXPIRED';
    }
};

export const getColorClass = statusId => {
    switch (statusId) {
        case onTrack:
            return '-color-bg-suc';

        case completed:
            return '-color-bg-suc';

        case offTrack:
            return '-color-bg-dkred';

        case expired:
            return '-color-bg-dan';

        default:
            return '-color-bg-grey';
    }
};

export const getStatusContext = statusId => {
    switch (statusId) {
        case onTrack:
            return 'suc';

        case completed:
            return 'suc';

        case goalReached:
            return 'suc';

        case offTrack:
            return 'dan';

        case expired:
            return 'dan';

        default:
            return null;
    }
};
